import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import axios from "axios";
import "./../styles/site.css";
import "./../styles/site/comprar.css";
import NavbarTop from "./site/Navbartop";
import Footer from "./site/Footer";
import * as globals from "./../components/GlobalScripts.js";

const Checkout = () => {
    const path_api = localStorage.getItem("path_api");
    const navigate = useNavigate();
    const [cargoPaypal, setCargoPaypal] = useState(false);
    const producto = {
        nombre: "Plan personalizado",
        precio: 79.99,
        divisa: "EUR",
        divisa_view: "€",
    };
    const [formData, setFormData] = useState({
        email: "",
        nombre: "",
        telefono: "",
    });

    useEffect(() => {
        localStorage.removeItem('session_id');
        localStorage.removeItem('keylogin');
        localStorage.removeItem('code_confirm');
        localStorage.removeItem('user');
    }, []);

    useEffect(() => {
        const fetchFacebookData = async () => {
            let facebookParams = globals.facebookParams();
            let event_source_url = facebookParams.event_source_url;
            let client_user_agent = facebookParams.client_user_agent;
            let event_time = facebookParams.event_time;
            let facebookPixel = facebookParams.facebookPixel;
            let facebookToken = facebookParams.facebookToken;
            let event_id = facebookParams.event_id;
    
            let data = {
                "event_source_url": event_source_url,
                "event_time": event_time,
                "client_user_agent": client_user_agent,
                "hostedBy": "Zadrig"
            };
    
            await window.fbq('track', 'PageView', data, { eventID: event_id });
            
            let fbp = facebookParams.fbp;
            let fbc = facebookParams.fbc;

            await fetch('https://zadrig.com/facebook/eventos/danithor/pageview.php', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    event_id: event_id,
                    facebookPixel: facebookPixel,
                    facebookToken: facebookToken,
                    event_time: event_time,
                    fbp: fbp,
                    fbc: fbc,
                    event_source_url: event_source_url,
                    client_user_agent: client_user_agent
                }),
           });
        };
    
        fetchFacebookData();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.nombre || !formData.email) {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Llena los campos",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000,
            });
            return;
        }

        let facebookParams = globals.facebookParams();
        let event_source_url = facebookParams.event_source_url;
        let client_user_agent = facebookParams.client_user_agent;
        let event_time = facebookParams.event_time;
        let facebookPixel = facebookParams.facebookPixel;
        let facebookToken = facebookParams.facebookToken;
        let event_id = facebookParams.event_id;

        let data = {
            "event_source_url": event_source_url,
            "event_time": event_time,
            "client_user_agent": client_user_agent,
            "content_name": producto.nombre,
            "value": producto.precio,
            "currency": producto.divisa,
            "hostedBy": "Zadrig"
        };

        await window.fbq('track', 'InitiateCheckout', data, { eventID: event_id });
        
        let fbp = facebookParams.fbp;
        let fbc = facebookParams.fbc;

        await fetch('https://zadrig.com/facebook/eventos/danithor/initiate_checkout.php', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                event_id: event_id,
                facebookPixel: facebookPixel,
                facebookToken: facebookToken,
                event_time: event_time,
                fbp: fbp,
                fbc: fbc,
                event_source_url: event_source_url,
                client_user_agent: client_user_agent,
                producto: producto.nombre,
                precio: producto.precio,
                divisa: producto.divisa,
            }),
        });

        globals.openViewCharge();
        await axios
            .post(`${path_api}/site/create.php`, {
                rute: globals.getRuteBackend(),
                name: formData.nombre,
                email: formData.email,
                envio_all: formData
            })
            .then(async (response) => {
                if (response.data.mensaje === "success") {  
                    localStorage.setItem('session_id', response.data.session_id);
                    localStorage.setItem('keylogin', response.data.keylogin);
                    localStorage.setItem('user', JSON.stringify(response.data.user));
                    setCargoPaypal(true);
                }else {
                    globals.createAlert({
                        type: "error",
                        msg_title: "Error",
                        msg: response.data.mensaje || "Sin comunicación con Danithor - log 1",
                        effect: "opacidad 2s, desplazamiento 2s",
                        time_life: 4000,
                    });
                }
                globals.closeViewCharge();
            })
            .catch((error) => {
                
                console.log(error)
                globals.createAlert({
                    type: "error",
                    msg_title: "Error 'log-account-1'",
                    msg: "Si persiste informa al soporte",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000,
                });
                globals.closeViewCharge();
            });
    };

    useEffect(() => {
        setCargoPaypal(false);
    }, [formData.nombre, formData.email]);

    const initialOptions = {
        "client-id": "ARZq62Z5x181pA4cg-SG0FdtvZ7if4G4X_GiUj-GkthPugHfciGGYCKzCe5d3nHnz9Hs6jhQMPS3GdzQ",
        // "client-id": "AUSodq5gbZZSSKD7ihnLFDHPFSliQapDWC2lWsLB59SKujMxh0naRjc8IdP-V57rcYz44n_CSjhAFH0c",
        currency: producto.divisa,
        intent: "capture",
    };

    const handleApprove = async (orderID) => {
        let facebookParams = globals.facebookParams();
        let event_source_url = facebookParams.event_source_url;
        let client_user_agent = facebookParams.client_user_agent;
        let event_time = facebookParams.event_time;
        let facebookPixel = facebookParams.facebookPixel;
        let facebookToken = facebookParams.facebookToken;
        let event_id = facebookParams.event_id;

        let data = {
            "event_source_url": event_source_url,
            "event_time": event_time,
            "client_user_agent": client_user_agent,
            "content_name": producto.nombre,
            "value": producto.precio,
            "currency": producto.divisa,
            "hostedBy": "Zadrig"
        };

        await window.fbq('track', 'Purchase', data, { eventID: event_id });
        
        let fbp = facebookParams.fbp;
        let fbc = facebookParams.fbc;

        await fetch('https://zadrig.com/facebook/eventos/danithor/purchase.php', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                event_id: event_id,
                facebookPixel: facebookPixel,
                facebookToken: facebookToken,
                event_time: event_time,
                email: formData.email,
                phone: formData.telefono,
                name: formData.nombre,
                fbp: fbp,
                fbc: fbc,
                event_source_url: event_source_url,
                client_user_agent: client_user_agent,
                producto: producto.nombre,
                precio: producto.precio,
                divisa: producto.divisa,
            }),
        });

        globals.openViewCharge();
        await axios
            .post(`${path_api}/site/aprobada.php`, {
                rute: globals.getRuteBackend(),
                nombre: producto.nombre,
                precio: producto.precio,
                divisa: producto.divisa,
                orderID: orderID,
                keylogin: globals.get_keylogin()
            })
            .then((response) => {
                if (response.data.mensaje === "success") {  
                    localStorage.setItem('code_confirm', '1');
                    globals.createAlert({
                        type: "success",
                        msg_title: "Aprobado",
                        msg: "Compra aprobada",
                        effect: "opacidad 2s, desplazamiento 2s",
                        time_life: 4000,
                    });
                    navigate(`/ty`);
                }else {
                    globals.createAlert({
                        type: "error",
                        msg_title: "Error",
                        msg: response.data.mensaje || "Sin comunicación con Danithor - log 2",
                        effect: "opacidad 2s, desplazamiento 2s",
                        time_life: 4000,
                    });
                }
                globals.closeViewCharge();
            })
            .catch((error) => {
                
                console.log(error)
                globals.createAlert({
                    type: "error",
                    msg_title: "Error 'log-account-2'",
                    msg: "Si persiste informa al soporte",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000,
                });
                globals.closeViewCharge();
            });
    };

    return (
        <PayPalScriptProvider options={initialOptions}>
        <div className="app-site app-container">
            <NavbarTop />
            <div className="main-content page-comprar">
                <div className="page-container">
                    <div className="container-section flex-column margin-top">
                        <div className="checkout-grid">
                            <div className="checkout-form container-section banner white">
                                <form onSubmit={handleSubmit}>
                                    <h2>Contacto</h2>

                                    <div className="form-group">
                                        <label htmlFor="nombre">Nombre</label>
                                        <input
                                            type="text"
                                            id="nombre"
                                            name="nombre"
                                            value={formData.nombre}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="email">Email</label>
                                        <input
                                            type="email"
                                            id="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="telefono">Teléfono</label>
                                        <input
                                            type="text"
                                            id="telefono"
                                            name="telefono"
                                            value={formData.telefono}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    {cargoPaypal && (
                                        <div className="paypal-container">
                                            <PayPalButtons
                                                style={{ layout: "vertical" }}
                                                createOrder={(data, actions) => {
                                                    return actions.order.create({
                                                        purchase_units: [
                                                            {
                                                                amount: {
                                                                    currency_code: producto.divisa,
                                                                    value: producto.precio,
                                                                },
                                                                description: producto.nombre,
                                                            },
                                                        ],
                                                    });
                                                }}
                                                onApprove={(data, actions) => {
                                                    return actions.order.capture().then((details) => {
                                                        handleApprove(details.id);
                                                    });
                                                }}
                                                onError={(err) => {
                                                    globals.createAlert({
                                                        type: "error",
                                                        msg_title: "Error",
                                                        msg: "Hubo un error al procesar el pago",
                                                        effect: "opacidad 2s, desplazamiento 2s",
                                                        time_life: 4000,
                                                    });
                                                }}
                                            />
                                        </div>
                                    )}
                                    
                                    {!cargoPaypal && (
                                        <button type="submit" className="button-primary button-desk">
                                            Finalizar compra
                                        </button>
                                    )}
                                </form>
                            </div>

                            <div className="checkout-summary">
                                <div className="cart-items-summary">
                                    <div className="summary-item">
                                        <div>
                                            <h4>{producto.nombre}</h4>
                                            <p>Cantidad: 1</p>
                                            <h3>${(producto.precio).toFixed(2)} {producto.divisa_view}</h3>
                                        </div>
                                    </div>

                                    <div className="order-summary">
                                        {!cargoPaypal && (
                                            <button
                                                onClick={() => document.querySelector('.button-desk')?.click()}
                                                className="button-primary button-mobile"
                                            >
                                                Finalizar compra
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
        </PayPalScriptProvider>
    );
};

export default Checkout;
